import { render, staticRenderFns } from "./VuePagination.vue?vue&type=template&id=0e237249"
import script from "./VuePagination.vue?vue&type=script&lang=js"
export * from "./VuePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports